import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal } from "antd";
import { createRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { _ckey } from "../../address";
import styles from "./otp.module.scss";
import { app_Cookie } from "../../tools/services";
import { useAPIPublic } from "../../tools/api";
import { convertPersian, formatMsisdn, waitForCaptchaLoad } from "../../tools/tools";
const OTP = ({
	callback,
	isOpen = false,
	msisdn = undefined,
	sessionid = undefined,
	certno = undefined,
	expiretimebyminute = undefined,
	checkmsisdnvcertno = undefined,
	certtype = undefined,
}) => {
	//State Hook ================================
	const [t] = useTranslation("global");
	const { sendOTPCodeAsync, confirmOTPCode, resendOTPCode } = useAPIPublic();
	//State Hook ================================

	//State for Control Props ================================
	const [otp, setOtp] = useState(["", "", "", "", ""]);
	const [openState, setOpenState] = useState(false);
	//State for Control Props ================================

	//State For Control Inputs ================================
	const inputRefs = Array(5)
		.fill(0)
		.map(() => createRef());
	const [frmOtp] = Form.useForm();
	//State For Control Inputs ================================

	//State Control For Submits ================================
	const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
	const [isProgress, setIsProgress] = useState(false);
	const [resendActive, setResendActive] = useState(false);
	const [remainTimeActive, setRemainTimeActive] = useState(false);
	//State Control For Submits ================================

	//State Control Timer ================================
	const [activeTimer, setActiveTimer] = useState(false);
	const [locsessionid, setLocSessionid] = useState(sessionid || 0);
	const [expiretime, setExpiretime] = useState(expiretimebyminute || 0);
	const [locMsisdn, setLocMsisdn] = useState(msisdn || 0);
	const [seconds, setSeconds] = useState(0);
	const [minutes, setMinutes] = useState(0);

	//State Control Timer ================================

	//control Fire Submit
	const [isSubmit, setIsSubmit] = useState(false);

	//Handle Call OTP Code =============================

	useEffect(() => {
		const callInitial = async () => {
			if (isOpen) {
				await handleAsyncOtp();
			}
		};
		callInitial();
	}, [isOpen]);

	const handleAsyncOtp = async () => {
		if (msisdn) {
			const captchaCode = await waitForCaptchaLoad();
			if (captchaCode) {
				let payload = {
					captcha: captchaCode,
					checkmsisdnvcertno: checkmsisdnvcertno,
					certno: certno,
					sessionid: sessionid,
					msisdn: msisdn,
					expiretimebyminute: expiretimebyminute,
					certtype: certtype,
				};

				let response = await sendOTPCodeAsync(payload);
				if (response) {
					setLocSessionid(response.sessionid);
					setExpiretime(parseInt(response.expiretime.split(":")[1]) * 60);
					setLocMsisdn(response.otpnumber);
					setActiveTimer(true);
					if (response?.otpcode) {
						let prev = [];
						response.otpcode.split("").forEach((element) => {
							prev.push(element);
						});
						setOtp(prev);
						setIsSubmitDisabled(false);
						frmOtp.setFieldValue("otp", 1);
					}
					setOpenState(isOpen);
				} else {
					callback(null);
				}
			}
		} else {
			callback(null);
		}
	};
	//Handle Call OTP Code =============================

	//Handle Timer Remain =============================
	var timer = 0;
	useEffect(() => {
		if (activeTimer) {
			const TimeCounter = () => {
				let dt = new Date();
				// let expTime = !isEmpty(app_Cookie(_ckey.expiretimeLogin)) ? parseInt(app_Cookie(_ckey.expiretimeLogin)) : Math.round(expiretime - 60);
				let expTime = Math.round(expiretime - 60);
				let counterDown = dt.setSeconds(dt.getSeconds() + expTime);
				timer = setInterval(() => {
					let now = new Date().getTime();
					let distance = counterDown - now;

					let minute = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
					setMinutes(minute);

					let second = Math.floor((distance % (1000 * 60)) / 1000);
					setSeconds(second);

					app_Cookie(_ckey.expiretimeLogin, minute * 60);

					if (distance < 0) {
						setMinutes(0);
						setSeconds(0);
						clearInterval(timer);
						setResendActive(true);
						setRemainTimeActive(false);
						setActiveTimer(false);
					}
				}, 1000);
				setRemainTimeActive(true);
			};
			TimeCounter();
			return () => clearInterval(timer);
		}
	}, [activeTimer]);
	//Handle Timer Remain =============================

	//handle Input Events & Cancel Status =================
	const handleInputChange = (e, index) => {
		const newValue = e.target.value;
		if (/^[0-9]*$/.test(newValue)) {
			const newOTP = [...otp];
			newOTP[index] = newValue;
			setOtp(newOTP);

			if (index < 4 && newValue !== "") {
				inputRefs[index + 1].current.focus();
			}
			const allInputsFilled = newOTP.every((value) => value !== "");
			setIsSubmitDisabled(!allInputsFilled);
			if (allInputsFilled) setIsSubmit(true);
		}
	};
	const handleInputBackspace = (e, index) => {
		if (e.keyCode === 8 && index > 0 && otp[index] === "") {
			const newOTP = [...otp];
			newOTP[index - 1] = "";
			setOtp(newOTP);
			// اگر عدد حذف شود، فوکوس به ورودی قبلی منتقل می‌شود
			inputRefs[index - 1].current.focus();
		}
	};
	const handleCancel = () => {
		setOpenState((prev) => !prev);
		callback(null);
	};
	//handle Input Events And Cancel Status =================

	//Check Is Submit =============================
	useEffect(() => {
		if (isSubmit) handleSubmit();
	}, [isSubmit]);

	//Handle Confrim OTP Code =================
	const handleSubmit = async () => {
		try {
			let valid = await frmOtp.validateFields();
			if (valid) {
				let optValue = inputRefs.map((ref) => ref?.current?.input?.value);
				setIsProgress(true);
				setIsSubmitDisabled(true);
				let payload = {
					sessionid: sessionid,
					otpvalue: optValue.join(""),
					userregistertype: 8,
				};
				let response = await confirmOTPCode(payload);
				if (response && !response?.HasError) {
					inputRefs.map((ref) => ref?.current?.input?.value);
					callback(response);
					clearInterval(timer);
					setOpenState(false);
				}
				setIsProgress(false);
				setIsSubmitDisabled(false);
			}
		} catch (error) {
			console.error(error);
			setIsProgress(false);
			setIsSubmitDisabled(false);
		}
		// setTimeout(() => {
		//   frmOtp.validateFields().then(async (value) => {

		//   });
		// });
	};
	//Handle Confrim OTP Code =================

	//Handle Resend OTP Code ==================
	const resendOTP = async (e) => {
		e.preventDefault();
		let payload = {
			sessionid: sessionid,
			expiretimebyminute: process.env.REACT_APP_LOGIN_EXPIRE,
		};
		let response = await resendOTPCode(payload);
		if (response) {
			setLocSessionid(response?.sessionid);
			setExpiretime(parseInt(response.expiretime.split(":")[1]) * 60);
			setActiveTimer(true);
		} else {
			setOpenState(false);
		}
	};
	//Handle Resend OTP Code ==================

	//initial Function Starts =============================

	//initial Function Starts =============================

	return (
		<>
			<Modal
				centered
				className={styles.modal_otp_container}
				onCancel={handleCancel}
				footer={
					<>
						<div className={`holder-button ${styles.holder_otp_confirm_button}`}>
							<Button className="btn-aptel" danger onClick={handleSubmit} disabled={isSubmitDisabled}>
								{isProgress ? <></> : <>تایید</>}
							</Button>
						</div>
					</>
				}
				width="25rem"
				open={openState}
				closeIcon={<CloseCircleOutlined />}>
				<div className={styles.holder_otp_confirm}>
					<div className={styles.holder_box_area}>
						<h3> دریافت کد </h3>
						<p>
							لطفا کد تایید ارسال شده به شماره موبایل <span dir="ltr">{formatMsisdn(msisdn)}</span> را وارد کنید
						</p>
						<div className={styles.holder_form}>
							<Form form={frmOtp} name="frmOtp">
								<Form.Item name="otp" className={styles.input_list} rules={[{ required: true, message: t("validation.required") }]}>
									<div className={styles.hold_row_input}>
										{otp.map((value, index) => (
											<Input
												key={index}
												autoComplete="off"
												name={`otp[${index}]`}
												ref={inputRefs[index]}
												value={value}
												onChange={(e) => {
													e.target.value = convertPersian(e.target.value);
													handleInputChange(e, index);
												}}
												onKeyDown={(e) => handleInputBackspace(e, index)}
												maxLength={1}
												className={styles.input_item}
											/>
										))}
									</div>
								</Form.Item>
								{remainTimeActive ? (
									<>
										{("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2) !== "00:00" && (
											<div className={styles.holder_remain_time}>
												<span dir="ltr">{("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2)}</span>
											</div>
										)}
									</>
								) : (
									<>
										<a className="resend" onClick={resendOTP} href="/#">
											ارسال مجدد کد
										</a>
									</>
								)}
							</Form>
						</div>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default OTP;
